import { ReactNode } from "react"
import mapPinIcon from "assets/svg/MapPin.svg"

type DutyLocationCardProp = {
  title: string
  location: string
  editIcon?: ReactNode
  deleteIcon?: ReactNode
  onEdit?: () => void
  onDelete?: () => void
}
const DutyLocationCard: React.FC<DutyLocationCardProp> = ({
  title,
  location,
  editIcon,
  deleteIcon,
  onEdit,
  onDelete,
}) => {
  return (
    <div className="bg-slate-100 rounded-md p-3">
      <div className="flex items-center justify-between">
        <p className="font-bold text-slate-900">{title}</p>
        <div className="flex items-center gap-1">
          {editIcon ? (
            <div
              onClick={onEdit}
              className="w-[2.25rem] h-[2.25rem] flex items-center justify-center cursor-pointer hover:bg-slate-200 rounded"
            >
              {editIcon}
            </div>
          ) : null}
          {editIcon && deleteIcon ? (
            <span className="w-px h-5 bg-slate-300 shrink-0" />
          ) : null}
          {deleteIcon ? (
            <div
              onClick={onDelete}
              className="w-[2.25rem] h-[2.25rem] flex items-center justify-center cursor-pointer hover:bg-slate-200 rounded"
            >
              {deleteIcon}
            </div>
          ) : null}
        </div>
      </div>
      <span className="flex items-center gap-1 mt-1">
        <img
          src={mapPinIcon}
          width={12}
          height={12}
        />
        <p className="text-sm font-medium">{location}</p>
      </span>
    </div>
  )
}

export default DutyLocationCard
